import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import SuperDiv from 'components/superDiv/SuperDiv'
import TypeIcon from 'components/typeIcon/TypeIcon'
import Spinner from 'components/spinner/Spinner'
import TreeRowEmpty from './TreeRowEmpty'

import PlayIcon from 'assets/icons/play.svg'

import treeStringify from 'utils/treeStringify'

import styles from './treeRowObject.scss'

interface IProps {
  path: string
  isSelected: boolean
  isExpanded: boolean
  fieldName?: string // Optional because we do not want it on the root
  modelName: string
  value: any
  isLoading: boolean
  style: React.CSSProperties
  onToggleCollapse: (path: string) => void
}

class TreeRowObject extends React.PureComponent<IProps> {
  handleToggleCollapse = (e: React.FormEvent<HTMLDivElement>) => {
    const { path, isLoading, onToggleCollapse } = this.props

    e.stopPropagation()

    if (isLoading) {
      return
    }

    onToggleCollapse(path)
  }

  handleExpand = (e: React.FormEvent<HTMLDivElement>) => {
    const { isExpanded } = this.props

    if (!isExpanded) {
      this.handleToggleCollapse(e)
    }
  }

  render() {
    const {
      path,
      isSelected,
      isExpanded,
      fieldName,
      modelName,
      value,
      isLoading,
      style,
    } = this.props

    const depth = path.split('::').length - 1

    return (
      <div
        data-cy="tree__object"
        data-cy-expanded="true"
        style={style}
        className={cn(styles.container, {
          [styles.expanded]: isExpanded,
          [styles.active]: !isExpanded && isSelected,
        })}
        tabIndex={1}
      >
        <div className={styles.depthGutter} style={{ width: depth * 16 }}></div>

        <div
          data-cy="expand-btn"
          className={styles.expandButton}
          onClick={this.handleToggleCollapse}
        >
          {isLoading && <Spinner size={3} className={styles.loader} />}
          {!isLoading && value && <PlayIcon />}
        </div>

        <div
          className={cn(styles.meta, {
            [styles.active]: isExpanded && isSelected,
          })}
          onClick={this.handleToggleCollapse}
        >
          <TypeIcon className={styles.icon} object required />
          {fieldName && <div className={styles.fieldName}>{fieldName}:</div>}
          <div className={styles.fieldType}>{modelName}</div>
        </div>

        <SuperDiv
          className={styles.fieldValue}
          onClickButNotDrag={this.handleExpand}
        >
          {value ? treeStringify(value, { maxLength: 150 }) : 'null'}
        </SuperDiv>
      </div>
    )
  }
}

export default observer(TreeRowObject)
